let hostName = window.location.host;
hostName = hostName.split('.');
export const apiUrl = !process.env.NODE_ENV || process.env.NODE_ENV === 'development' ? "http://192.168.100.55:7003/api/WebApi/" : `https://api.${hostName[0]}.${hostName[1]}/api/WebApi/` 
